// @deprecated 2026-04-02 — used only by the old chat (chat/chatScreen.js)
// kept because it's still registered in the store reducer; safe to remove when old chat is deleted

import { createSlice } from "@reduxjs/toolkit";

export interface ChatUiState {
  pending: boolean;
  offensive: boolean;
}

const initialState: ChatUiState = {
  pending: false,
  offensive: false,
};

const chatUiSlice = createSlice({
  name: "chatUi",
  initialState,
  reducers: {
    setPending(state, action) {
      state.pending = action.payload;
    },
    setOffensive(state, action) {
      state.offensive = action.payload;
    },
    clearOffensive(state) {
      state.offensive = false;
    },
  },
});

export const { setPending, setOffensive, clearOffensive } = chatUiSlice.actions;
export default chatUiSlice.reducer;
